import { usePackageBookingStore } from "@elixir/stores";
import { PACKAGE_POPUP_TYPE } from "@elixir/types";
import React, { useEffect } from "react";
import useGetPatientOverview from "../../../../apis/tryst/use-get-patient-overview";
import { track } from "../../../../utils/tracking";

const StartOrCurrentTreatment = () => {
  React.useEffect(() => {
    track("start_or_current_treatment_popup");
  }, []);

  const selectedAppointment = usePackageBookingStore(
    (state) => state.selectedAppointment
  );
  const selectedPatient = usePackageBookingStore(
    (state) => state.selectedPatient
  );

  const { data, isLoading } = useGetPatientOverview({
    patientId: selectedPatient?.oid || selectedAppointment?.patient_oid!,
  });

  const isPackageAvailable =
    data?.package?.package_id && !data?.package?.archive;

  const setPackagePopupType = usePackageBookingStore(
    (state) => state.setPackagePopupType
  );

  useEffect(() => {
    if (isLoading) return;
    if (isPackageAvailable) {
      setPackagePopupType(PACKAGE_POPUP_TYPE.CURRENT_TREATMENT);
    } else {
      setPackagePopupType(PACKAGE_POPUP_TYPE.START_TREATMENT);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isLoading, isPackageAvailable]);

  return <></>;
};

export default StartOrCurrentTreatment;
